import styled from 'styled-components';

const SectionSelectorStyled = {
    Container: styled.div``,
};

export default SectionSelectorStyled;
